import { render, staticRenderFns } from "./echartsview.vue?vue&type=template&id=34c82f60"
import script from "./echartsview.vue?vue&type=script&lang=js"
export * from "./echartsview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34c82f60')) {
      api.createRecord('34c82f60', component.options)
    } else {
      api.reload('34c82f60', component.options)
    }
    module.hot.accept("./echartsview.vue?vue&type=template&id=34c82f60", function () {
      api.rerender('34c82f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/echartsview.vue"
export default component.exports